export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8185.db1c5fc2.jpg";